import React, { useEffect, useState } from 'react'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import styles from './SearchBox.module.css'

function SearchDistrict({setSelectedDistrict,state,stateData,selectedDistrict}) {

    const [district,setDistrict]=useState([]);

    const populateDistrict =  () =>{      
        stateData.filter((obj)=> obj.value.toLowerCase().includes(state?.toLowerCase()))?.map((obj)=>
          setDistrict(obj.items)
        )
          
    }

      useEffect(() => {
        populateDistrict()
      }, [state])

    return (
        <>
            <Dropdown options={district} placeholder="Select a District" value={selectedDistrict ? selectedDistrict : "Please Select a District"} onChange={(selected)=> setSelectedDistrict(selected.value)}/>
        </>
    )
}

export default SearchDistrict
